import { render, staticRenderFns } from "./AddCaseReasons.vue?vue&type=template&id=60d6eeac&"
import script from "./AddCaseReasons.vue?vue&type=script&lang=js&"
export * from "./AddCaseReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports